export function getZendeskArticle(organizationCountry = 'fr', articleSlug, articleLanguage = 'fr') {
  let orgCountry = organizationCountry;
  let articleLang = articleLanguage;

  if (!organizationCountry) orgCountry = 'fr';
  if (!articleLanguage) articleLang = 'fr';

  let baseUrl = `https://support-${orgCountry}.qonto.com/hc/${articleLang}`;

  return articleSlug?.[orgCountry] ? `${baseUrl}/articles/${articleSlug?.[orgCountry]}` : baseUrl;
}
